<template>
  <div class="mydevice">
    <div class="fr ac jsb">
      <p>我的设备</p>
      <el-button type="text" @click="go('adddevice')">添加设备</el-button>
    </div>
    <el-divider />
    <div class="main">
      <div class="deivce_cell fr ac mb20" v-for=" i in devices_list" :key="i.company_device_id">
        <img :src="i.company_device_img" alt class="fs" />
        <div class="fs fg ml20">
          <p>{{i.deviceBean.device_name}}</p>
          <p class="mt20">机器别名:{{i.company_device_name}}</p>
          <div class="fr ac jsb mt20">
            <p
              class="blue cursor"
              style="text-decoration: underline;"
              @click="go(`maintain?id=${i.company_device_id}`)"
            >维护记录</p>
            <div class="fr ac">
              <el-button
                type="text"
                class="black"
                size="mini"
                @click="go(`addrecord?id=${i.company_device_id}`)"
              >添加记录</el-button>

              <el-button
                type="text"
                class="black"
                size="mini"
                @click="deleteMemberDevice(i.company_device_id)"
              >删除机器</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="fr ac jc">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :current-page.sync="page"
          class="mt20 mb20"
          background
          :hide-on-single-page="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      total: 0,
      page: 1,
      devices_list: []
    };
  },
  created() {
    this.getMemberDevices();
  },
  watch: {
    page(n) {
      this.getMemberDevices();
    }
  },
  methods: {
    deviceevaluation(info) {
      this.set("device_detail", info, 1);
      this.go("deviceevaluation");
    },
    // 删除设备
    deleteMemberDevice(id) {
      this.$confirm("此操作将删除该设备, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.post("companyInterfaces/v1.0/deleteCompanyDevice", {
            company_device_id: id
          }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getMemberDevices();
          });
        })
        .catch(() => {});
    },
    // 获取设备列表
    getMemberDevices() {
      this.post("companyInterfaces/v1.0/getCompanyDeviceList", {
        page: this.page
      }).then(res => {
        this.devices_list = res.data;
        this.total = res.total;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.mydevice {
  font-size: 14px;
  .main {
    .deivce_cell {
      width: 100%;
      padding: 10px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myDevice/index.vue